<div class="main-wrapper">

    <div class="login-wrapper">

        <div class="header">
            <div class="header-logo"><img src="../../../assets//img/login_logo.png"></div>
            <div class="header-language-selectors">
                <div (click)="changeLang('es')"><img style="margin-right: 8px"
                        src="../../../assets/img/flags/es_black.png">
                </div>
                <div (click)="changeLang('cat')"><img style="margin-right: 8px"
                        src="../../../assets/img/flags/cat_black.png">
                </div>
                <div (click)="changeLang('en')"><img src="../../../assets/img/flags/en_black.png"></div>
            </div>
        </div>



        <div class="login-form" [formGroup]="loginForm">

            <mat-form-field appearance="outline">
                <input matInput placeholder="{{ 'login.student_id' | translate }}" [formControlName]="'student_id'">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input matInput placeholder="{{ 'inputs.name' | translate }}" [formControlName]="'name'">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input matInput placeholder="Email" type="email" [formControlName]="'email'">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input matInput placeholder="{{ 'inputs.phone' | translate }}" [formControlName]="'phone'">
            </mat-form-field>

            <mat-checkbox value="conditions" class="checkbox">{{ 'login.accept_the' | translate }} <a href="https://makneticfoto.com/condiciones-venta">{{ 'login.terms_and_conditions' | translate }}</a>*</mat-checkbox>
            <mat-checkbox value="allowNotifications" class="checkbox">{{ 'login.accept_notifications' | translate }}</mat-checkbox>

        </div>

        <div class="login-actions">
            <div class="login-button-wrapper">
                <button mat-flat-button class="login-button " (click)="createAccount()"><span
                        style="text-transform: uppercase">{{
                        'login.create_account' | translate }}</span></button>
            </div>
            <div class="action-button-wrapper">
                <button mat-flat-button class="action-button" (click)="redirectToWeb()">
                    <mat-icon>keyboard_arrow_left</mat-icon> {{ 'login.go_back_to_web' | translate }}
                </button>
                <button mat-flat-button class="action-button" routerLink="/login">
                    <mat-icon>keyboard_arrow_left</mat-icon> {{ 'login.go_back_to_login' | translate }}
                </button>
            </div>
            <div class="login-content">
                <p>{{ 'login.intro_paragraph' | translate }}</p>
                <p style="font-weight: 600; font-size: 14px;">{{ 'login.intro_warning' | translate }}</p>
            </div>
        </div>

    </div>

</div>